import { Modal, ModalBody, Input } from "reactstrap";
import { useState } from "react";

export const RejectModal = ({ 
  show, 
  onRejectClick, 
  onCloseClick, 
  onChange, 
  reason,
  title = "Confirm Rejection",
  message = "Are you sure you want to reject this? This action cannot be undone.",
  rejectButtonText = "Reject",
  reasonPlaceholder = "Please provide a reason for rejecting this"
}) => {
  const [isReasonValid, setIsReasonValid] = useState(true);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);

  const handleReject = () => {
    setAttemptedSubmit(true);
    const isValid = reason && reason.trim().length > 0;
    setIsReasonValid(isValid);
    
    if (isValid) {
      console.log("Rejection reason:", reason);
      onRejectClick();
    }
  };

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button
            type="button"
            onClick={onCloseClick}
            className="btn-close position-absolute end-0 top-0 m-3"
          ></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-danger text-danger bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi mdi-close-circle"></i>
            </div>
          </div>
          {title && <h5 className="mb-3">{title}</h5>}
          <p className="text-muted font-size-16 mb-4">
            {message}
          </p>
          
          <div className="mb-3">
            <Input
              type="textarea"
              id="rejectReason"
              value={reason}
              onChange={onChange}
              placeholder={reasonPlaceholder}
              rows="3"
              style={{ resize: "none" }}
              required
              invalid={attemptedSubmit && !isReasonValid}
            />
            {attemptedSubmit && !isReasonValid && (
              <div className="text-danger mt-1 text-start">
                <small>Rejection reason is required</small>
              </div>
            )}
          </div>
  
          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleReject}
            >
              {rejectButtonText}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCloseClick}
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};